import { Link } from 'react-router-dom'
import { useApp } from '../../../context/App'

interface Props {
    title: string
    isActive?: boolean
    href?: string
    onClick?: () => void
    className?: string
}

/**
 * Componente genérico para itens de categoria/lista com suporte a links ou ações de clique.
 */
export function ItemCategory({ title, isActive, href, onClick, className }: Props) {
    const { configDomainURL } = useApp()

    const baseClass = [
        'font-roboto cursor-pointer transition-all duration-200',
        'hover:underline',
        isActive
            ? 'text-primary dark:text-secondary font-semibold'
            : 'text-on-surface-muted dark:text-on-surface-dark-muted font-normal hover:text-primary dark:hover:text-secondary',
    ].join(' ')

    const finalClass = `${baseClass} ${className || ''}`

    if (href) {
        const isInternal = href.startsWith('/') && !href.startsWith('//')
        const finalHref = href.startsWith('http') || href.startsWith('/') ? href : `${configDomainURL}${href}`

        if (isInternal) {
            return (
                <Link to={href} onClick={onClick} className={finalClass + ' no-underline'}>
                    {title}
                </Link>
            )
        }

        return (
            <a href={finalHref} onClick={onClick} className={finalClass + ' no-underline'} target={href.startsWith('http') ? '_blank' : '_self'} rel="noreferrer">
                {title}
            </a>
        )
    }

    return (
        <div onClick={onClick} className={finalClass}>
            {title}
        </div>
    )
}
